import styles from "./PriceListAdditionalItem.module.scss";
import React from "react";

function PriceListAdditionalItem({ title, price, description, icon }) {
    return (
        <div className={styles.card}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <h4 className={styles.title}>{title}</h4>
            <p className={styles.body}>{description}</p>
            <div className={styles.footer}>
                <span className={styles.price}>{price}</span>
                <a className={styles.link} href="mailto:hallo@laufid.is">
                    Hafa samband →
                </a>
            </div>
        </div>
    );
}

export default PriceListAdditionalItem;
